import { createReducer } from '@reduxjs/toolkit';

import resetPassword, { clearResetPassword } from '../../thunks/auth/resetPassword';

const initialState = {
  loading: false,
  error: null,
  data: null
};

const resetPasswordReducer = createReducer(initialState, {
  [resetPassword.pending]: (state) => ({
    ...state,
    loading: true,
    error: null,
  }),

  [resetPassword.fulfilled]: (state, { payload: data }) => ({
    ...state,
    loading: false,
    data,
  }),

  [clearResetPassword]: () => initialState,

  [resetPassword.rejected]: (state, { payload: error }) => ({
    ...state,
    loading: false,
    error,
    data: null
  })
});

export default resetPasswordReducer;
